import { AiOutlineFire } from "react-icons/ai";
import { GrCertificate } from "react-icons/gr";


const AboutBox = () => {
  return (
    <div className='about__boxes grid'>
      <div className='about__box'>
        <AiOutlineFire className="about__icon" />

        <div>
          <h3 className='about__title'>10</h3>
          <span className='about__subtitle'>Completed Projects</span>
        </div>
      </div>

      <div className='about__box'>
        <GrCertificate className="about__icon" />

        <div>
          <h3 className='about__title'>6</h3>
          <span className='about__subtitle'>Achieved Certificates</span>
        </div>
      </div>
    </div>
  )
}

export default AboutBox